import axios from "axios";
import React, { useEffect, useState } from "react";
import WinnerDisplayFrame from "./WinnerDisplayFrame";
import Accordian from "../Accordian/Accordian";
import Loading from "../Loading/Loading";
import _, { isEmpty } from "lodash";
import RulesBox from "../RulesBox/RulesBox";
import giftIcon from "../../assests/giftIcon.svg";
import worksIcon from "../../assests/worksIcon.svg";
import stepsIcon from "../../assests/stepsIcon.svg";
import rulesIcon from "../../assests/rulesIcon.svg";

export default function Winners({ details, contestDetails, setWinningArray }) {
  const [winnersData, setWinnersData] = useState({});
  const [filter, setFilter] = useState("contestWinners");
  const [winnerLoading, setWinnerLoading] = useState(false);
  useEffect(() => {
    if (contestDetails && contestDetails?.winnerSelected) {
      getWinners(
        contestDetails?.campaignId,
        contestDetails?.orgId,
        contestDetails?.contestId
      );
    }
  }, [contestDetails?.contestId]);
  useEffect(() => {
    const filterSelected = selectFilter();
    setFilter(filterSelected);
  }, []);
  const selectFilter = () => {
    if (contestDetails?.judgeWinnerSelected) {
      return "contestWinners";
    } else if (contestDetails?.crowdWinnerSelected) {
      return "crowdWinners";
    } else if (contestDetails?.specialWinnerSelected) {
      return "crowdWinners";
    } else {
      return "overview";
    }
  };
  const getWinners = async (campaignId, orgId, contestId) => {
    setWinnerLoading(true);
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_GET_WINNERS_LIST}/${campaignId}/${orgId}/${contestId}`
      );
      setWinnersData(data?.data?.data);
      setWinningArray(data?.data?.data);
      setWinnerLoading(false);
    } catch (error) {
      setWinnerLoading(false);
      console.log(error.message);
    }
  };
  let selectedWinners = {
    color: contestDetails?.buttonColor,
    borderColor: contestDetails?.buttonColor,
  };
  return (
    <div>
      <div className="w-full text-regular-bold flex gap-[16px] text-[#CDCDCD] whitespace-nowrap mb-[20px] overflow-x-auto no-scrollbar cursor-pointer">
        {contestDetails?.judgeWinnerSelected && (
          <buttton
            className={`py-[12px] ${
              filter === "contestWinners" ? `border-b-[2px] ` : "text-[#CDCDCD]"
            }`}
            style={filter === "contestWinners" ? selectedWinners : {}}
            onClick={() => setFilter("contestWinners")}
          >
            Contest Winner
          </buttton>
        )}
        {contestDetails?.crowdWinnerSelected && (
          <buttton
            className={`py-[12px] ${
              filter === "crowdWinners" ? `border-b-[2px] ` : "text-[#CDCDCD]"
            }`}
            style={filter === "crowdWinners" ? selectedWinners : {}}
            onClick={() => setFilter("crowdWinners")}
          >
            Crowd winner
          </buttton>
        )}
        {!isEmpty(winnersData?.specialWinners) && (
          <buttton
            className={`py-[12px] ${
              filter === "specialWinners" ? `border-b-[2px] ` : "text-[#CDCDCD]"
            }`}
            style={filter === "specialWinners" ? selectedWinners : {}}
            onClick={() => setFilter("specialWinners")}
          >
            Special Recognition
          </buttton>
        )}
        <buttton
          className={`py-[12px] ${
            filter === "overview" ? `border-b-[2px] ` : "text-[#CDCDCD]"
          }`}
          style={filter === "overview" ? selectedWinners : {}}
          onClick={() => setFilter("overview")}
        >
          Overview
        </buttton>
      </div>
      {winnerLoading && <Loading />}
      <div className="flex flex-wrap gap-[20px] mb-[20px]">
        {filter == "contestWinners" &&
          (winnersData?.judgeWinners?.length <= 0 ? (
            <div className="w-[100%] py-[30px] flex flex-col items-center justify-center text-[#d1d1d1] relative z-10">
              <span className="text-small ">
                {contestDetails?.judgeWinnerNotSelectReason || "No Winners yet"}
              </span>
            </div>
          ) : (
            winnersData?.judgeWinners?.map((obj, index) => {
              return <WinnerDisplayFrame data={obj} position={index + 1} />;
            })
          ))}
        {filter == "crowdWinners" &&
          (winnersData?.crowdWinners?.length <= 0 ? (
            <div className="w-[100%] py-[30px] flex flex-col items-center justify-center text-[#d1d1d1]  relative z-10">
              <span className="text-small">
                {contestDetails?.crowdWinnerNotSelectReason || "No Winners yet"}
              </span>
            </div>
          ) : (
            winnersData?.crowdWinners?.map((obj, index) => {
              return <WinnerDisplayFrame data={obj} position={index + 1} />;
            })
          ))}
        {filter == "specialWinners" &&
          (winnersData?.specialWinners?.length <= 0 ? (
            <div className="w-[100%] py-[30px] flex flex-col items-center justify-center text-[#d1d1d1]  relative z-10">
              <span className="text-[17px] font-semibold">
                {contestDetails?.specialWinnerNotSelectReason ||
                  "No Winners yet"}
              </span>
            </div>
          ) : (
            winnersData?.specialWinners?.map((obj, index) => {
              return <WinnerDisplayFrame data={obj} position={index + 1} />;
            })
          ))}

        {filter == "overview" && (
          <div className="grid grid-cols-4 gap-[10px] mb-[20px]">
            {!_.isEmpty(details?.howToParticipate?.description) && (
              <RulesBox heading="Contest About" svg={worksIcon}>
                <pre className="text-small mb-[24px] text-[#cdcdcd]">
                  {contestDetails?.description}
                </pre>
              </RulesBox>
            )}
            {!_.isEmpty(contestDetails?.howItsWorks) && (
              <RulesBox heading="Steps to participate" svg={stepsIcon}>
                <div className="text-small mb-[32px]">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${contestDetails?.howItsWorks}`,
                    }}
                    className="flex flex-col gap-[12px] text-[#CDCDCD]"
                  />
                </div>
              </RulesBox>
            )}
            {!_.isEmpty(contestDetails?.contestRules) && (
              <RulesBox heading="Contest Rules" svg={rulesIcon}>
                <div className="text-small mb-[32px]">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${contestDetails?.contestRules}`,
                    }}
                    className="flex flex-col gap-[12px] text-[#CDCDCD]"
                  />
                </div>
              </RulesBox>
            )}
            {(details?.certificate ||
              contestDetails?.priceDescription ||
              !_.isEmpty(contestDetails?.prizeObj)) && (
              <RulesBox heading="Prize details" svg={giftIcon}>
                <div className="text-small mb-[32px]">
                  <div class="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point">
                    {contestDetails?.judgeWinnerAvailable && (
                      <>
                        <p>
                          <strong>Contest prize</strong>
                        </p>
                        <ol>
                          {contestDetails?.prizeObj?.judgeWinner[1] && (
                            <li>
                              First prize:{" "}
                              {
                                contestDetails?.prizeObj?.judgeWinner[1]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.judgeWinner[2] && (
                            <li>
                              Second prize:{" "}
                              {
                                contestDetails?.prizeObj?.judgeWinner[2]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.judgeWinner[3] && (
                            <li>
                              Third prize:{" "}
                              {
                                contestDetails?.prizeObj?.judgeWinner[3]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.judgeWinner?.general && (
                            <p>
                              {
                                contestDetails?.prizeObj?.judgeWinner?.general
                                  ?.prizeWorth
                              }
                            </p>
                          )}
                        </ol>
                        <p></p>
                      </>
                    )}

                    {contestDetails?.crowdWinnerAvailable && (
                      <>
                        <p>
                          <strong>Crowd Winner</strong>
                        </p>
                        <ol>
                          {contestDetails?.prizeObj?.crowdWinner[1] && (
                            <li>
                              First prize:{" "}
                              {
                                contestDetails?.prizeObj?.crowdWinner[1]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.crowdWinner[2] && (
                            <li>
                              Second prize:{" "}
                              {
                                contestDetails?.prizeObj?.crowdWinner[2]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.crowdWinner[3] && (
                            <li>
                              Third prize:{" "}
                              {
                                contestDetails?.prizeObj?.crowdWinner[3]
                                  ?.prizeWorth
                              }
                            </li>
                          )}
                          {contestDetails?.prizeObj?.crowdWinner?.general && (
                            <p>
                              {
                                contestDetails?.prizeObj?.crowdWinner?.general
                                  ?.prizeWorth
                              }
                            </p>
                          )}
                        </ol>
                        <p></p>
                      </>
                    )}
                    {contestDetails?.specialWinnerAvailable && (
                      <>
                        <p>
                          <strong>Special Winner</strong>
                        </p>

                        {contestDetails?.prizeObj?.specialWinner?.general && (
                          <p>
                            {
                              contestDetails?.prizeObj?.specialWinner?.general
                                ?.prizeWorth
                            }
                          </p>
                        )}
                        <p></p>
                      </>
                    )}

                    {details?.certificate && (
                      <>
                        <p>
                          <strong>Certificate</strong>
                        </p>
                        <p>E-certificate for all contestants</p>
                        <p></p>
                      </>
                    )}
                    <p></p>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${contestDetails?.priceDescription}`,
                    }}
                    className="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point"
                  />
                </div>
              </RulesBox>
            )}
          </div>
          // <div className="w-[100%]">
          //   <Accordian
          //     summary="Prize details"
          //     buttonColor={contestDetails?.buttonColor}
          //   >
          //     <div className="text-small mb-[32px]">
          //       <div class="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point">
          //         {contestDetails?.judgeWinnerAvailable && (
          //           <>
          //             <p>
          //               <strong>Contest prize</strong>
          //             </p>
          //             <ol>
          //               {contestDetails?.prizeObj?.judgeWinner[1] && (
          //                 <li>
          //                   First prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.judgeWinner[1]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.judgeWinner[2] && (
          //                 <li>
          //                   Second prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.judgeWinner[2]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.judgeWinner[3] && (
          //                 <li>
          //                   Third prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.judgeWinner[3]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.judgeWinner?.general && (
          //                 <p>
          //                   {
          //                     contestDetails?.prizeObj?.judgeWinner?.general
          //                       ?.prizeWorth
          //                   }
          //                 </p>
          //               )}
          //             </ol>
          //             <p></p>
          //           </>
          //         )}

          //         {contestDetails?.crowdWinnerAvailable && (
          //           <>
          //             <p>
          //               <strong>Crowd Winner</strong>
          //             </p>
          //             <ol>
          //               {contestDetails?.prizeObj?.crowdWinner[1] && (
          //                 <li>
          //                   First prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.crowdWinner[1]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.crowdWinner[2] && (
          //                 <li>
          //                   Second prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.crowdWinner[2]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.crowdWinner[3] && (
          //                 <li>
          //                   Third prize:{" "}
          //                   {
          //                     contestDetails?.prizeObj?.crowdWinner[3]
          //                       ?.prizeWorth
          //                   }
          //                 </li>
          //               )}
          //               {contestDetails?.prizeObj?.crowdWinner?.general && (
          //                 <p>
          //                   {
          //                     contestDetails?.prizeObj?.crowdWinner?.general
          //                       ?.prizeWorth
          //                   }
          //                 </p>
          //               )}
          //             </ol>
          //             <p></p>
          //           </>
          //         )}
          //         {contestDetails?.specialWinnerAvailable && (
          //           <>
          //             <p>
          //               <strong>Special Winner</strong>
          //             </p>

          //             {contestDetails?.prizeObj?.specialWinner?.general && (
          //               <p>
          //                 {
          //                   contestDetails?.prizeObj?.specialWinner?.general
          //                     ?.prizeWorth
          //                 }
          //               </p>
          //             )}
          //             <p></p>
          //           </>
          //         )}

          //         {details?.certificate && (
          //           <>
          //             <p>
          //               <strong>Certificate</strong>
          //             </p>
          //             <p>E-certificate for all contestants</p>
          //             <p></p>
          //           </>
          //         )}
          //         <p></p>
          //       </div>
          //       <div
          //         dangerouslySetInnerHTML={{
          //           __html: `${contestDetails?.priceDescription}`,
          //         }}
          //         className="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point"
          //       />
          //     </div>
          //   </Accordian>
          //   <div className="seperator " />
          //   <Accordian
          //     summary="How this contest works ?"
          //     buttonColor={contestDetails?.buttonColor}
          //   >
          //     <div
          //       className=" text-small mb-[32px] star-bullet-point text-[#CDCDCD]"
          //       // style={{ color: contestDetails?.buttonColor }}
          //       dangerouslySetInnerHTML={{
          //         __html: `${details?.howToParticipate?.description}`,
          //       }}
          //     />
          //   </Accordian>
          //   <div className="seperator " />
          //   <Accordian
          //     summary="Steps to participate"
          //     buttonColor={contestDetails?.buttonColor}
          //   >
          //     <div className="text-small mb-[32px]">
          //       <div
          //         dangerouslySetInnerHTML={{
          //           __html: `${contestDetails?.howItsWorks}`,
          //         }}
          //         className="flex flex-col gap-[12px] text-[#CDCDCD]"
          //       />
          //     </div>
          //   </Accordian>
          //   <div className="seperator " />
          //   {!_.isEmpty(contestDetails?.contestRules) && (
          //     <>
          //       <Accordian
          //         summary="Contest Rules"
          //         buttonColor={contestDetails?.buttonColor}
          //       >
          //         <div className="text-small mb-[32px]">
          //           <div
          //             dangerouslySetInnerHTML={{
          //               __html: `${contestDetails?.contestRules}`,
          //             }}
          //             className="flex flex-col gap-[12px] text-[#CDCDCD]"
          //           />
          //         </div>
          //       </Accordian>
          //     </>
          //   )}
          // </div>
        )}
      </div>
    </div>
  );
}
